import { useEffect, useState } from 'react'

export type Route = { name: string; parts: string[]; query: URLSearchParams }

function parse(): Route {
  const raw = location.hash.replace(/^#\/?/, '')
  const [path, qs] = raw.split('?')
  const parts = path ? path.split('/').filter(Boolean) : []
  return { name: parts[0] ?? '', parts, query: new URLSearchParams(qs ?? '') }
}

export function useRoute(): Route {
  const [r, setR] = useState<Route>(parse)
  useEffect(() => {
    const h = () => setR(parse())
    addEventListener('hashchange', h)
    return () => removeEventListener('hashchange', h)
  }, [])
  return r
}

export const go = (path: string) => { location.hash = '#/' + path.replace(/^\//, '') }
